import { supabase } from '@/lib/supabase';
import { Region, RegionWithCounts } from '@/features/regions/types';

export const regionQueries = {
  /**
   * Get all regions for a provider
   */
  getRegions: async (providerId: number): Promise<Region[]> => {
    const { data, error } = await supabase
      .from('regions')
      .select('*')
      .eq('provider_id', providerId)
      .order('name');

    if (error) throw error;
    return data as Region[];
  },

  /**
   * Get a single region by ID
   */
  getRegionById: async (id: number): Promise<Region> => {
    const { data, error } = await supabase
      .from('regions')
      .select('*')
      .eq('id', id)
      .single();

    if (error) throw error;
    return data as Region;
  },

  /**
   * Get regions with version counts
   */
  getRegionsWithCounts: async (providerId: number): Promise<RegionWithCounts[]> => {
    const { data, error } = await supabase.rpc('get_regions_with_version_counts', {
      p_provider_id: providerId
    });

    if (error) throw error;
    return data as RegionWithCounts[];
  },

  /**
   * Find regions by zip code
   * This will be useful for future API integrations
   */
  findRegionsByZipCode: async (zipCode: string): Promise<Region[]> => {
    // First trim the zip code to handle any whitespace
    const trimmedZipCode = zipCode.trim();
    
    if (!trimmedZipCode) {
      return [];
    }
    
    const { data, error } = await supabase.rpc('find_regions_by_zip_code', {
      p_zip_code: trimmedZipCode
    });

    if (error) throw error;
    return data as Region[];
  }
};
